import { createFileRoute } from '@tanstack/react-router';
import PlacePage from '../../views/dashboard-places/place';

export const Route = createFileRoute('/dashboard/places_/$uuid')({
  component: PlacePage,
});
